import { Box, FloatingPosition, Popover } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { PropsWithChildren, ReactNode } from 'react';

export default function RichTooltip({
  content,
  children,
  position = 'right-end',
}: PropsWithChildren<{ content: ReactNode; position?: FloatingPosition }>) {
  const [opened, { close, open }] = useDisclosure(false);
  return (
    <Popover
      width={200}
      position={position}
      withArrow
      shadow="md"
      middlewares={{
        flip: true,
        shift: true,
      }}
      keepMounted={false}
      opened={opened}
    >
      <Popover.Target>
        <Box onMouseEnter={open} onMouseLeave={close}>
          {children}
        </Box>
      </Popover.Target>
      <Popover.Dropdown>{content}</Popover.Dropdown>
    </Popover>
  );
}
